import { render, staticRenderFns } from "./adPay.vue?vue&type=template&id=76ef4bcf&scoped=true"
import script from "./adPay.vue?vue&type=script&lang=js"
export * from "./adPay.vue?vue&type=script&lang=js"
import style0 from "./adPay.vue?vue&type=style&index=0&id=76ef4bcf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76ef4bcf",
  null
  
)

export default component.exports